<template>
  <main>
    <Loader v-if="loaderStore.load[5]" :loader="loaderStore.load[5]" />
    <div v-else-if="currentMaterial?.file" ref="material">
      <SkipVideo
        v-if="materialStore.skipVideoModal"
        :skipModal="materialStore.skipVideoModal"
        @onSkipVideo="materialStore.onSkipVideo"
      />
      <Dialog
        v-model:visible="showAlert"
        :draggable="false"
        :breakpoints="{ '960px': '95vw', '640px': '95vw' }"
        :style="{ width: '25vw', minWidth: '360px' }"
        modal
        v-if="materialStore.isVideo"
      >
        <template #header>
          <section class="flex items-center gap-3">
            <i class="pi pi-info-circle !text-3xl text-h-warning-400"></i>
            <h3>
              {{ $t("labels.generic", { pt: `Alerta`, en: `Alert` }) }}
            </h3>
          </section>
        </template>
        <p
          class="text-xl"
          v-html="
            'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
          "
        ></p>
      </Dialog>
      <CourseLearningMapStudent
        v-if="materialStore.showMap"
        @onCloseMap="materialStore.setShowMap"
      />
      <section class="col-span-12">
        <div
          class="px-3 mt-4 flex items-center flex-col w-full"
          v-if="
            currentMaterial?.file?.url &&
            materialStore.materials[0]?.file.status === 'DONE'
          "
          v-motion
          :initial="initialMotion"
          :enter="enterMotion"
        >
          <div
            v-if="typeModalHeader === 'STUDENT'"
            class="flex flex-col sm:flex-row w-full min-w-[360px] justify-start sm:justify-between items-start sm:items-center sticky top-0 p-3 bg-[#f8f9fa] rounded-sm gap-3 z-50"
          >
            <div class="flex items-center gap-4">
              <div class="flex items-center gap-5 w-fit">
                <h4>{{ currentMaterial?.name }}</h4>
              </div>

              <div
                id="tips"
                v-if="materialStore.isVideo"
                class="group w-fit flex !justify-start lg:!justify-center"
              >
                <i
                  class="pi pi-exclamation-circle cursor-pointer text-white bg-h-warning-400 px-1 !text-xl rounded-full hover:scale-75 transition-all animate-bounce-short"
                />
                <div
                  class="hidden absolute transition-all group-hover:flex group-focus:flex bg-white p-3 w-64 mt-8 rounded-lg !z-50 shadow-md border overflow-hidden break-words whitespace-normal"
                >
                  <p
                    v-html="
                      'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
                    "
                  ></p>
                </div>
              </div>
            </div>

            <div
              :class="[
                'w-full  flex justify-end items-center gap-5 z-50 sm:w-[50%]',
              ]"
            >
              <HistoryMaterials
                v-if="currentMaterial"
                :materials="materialStore.materials"
                :currentMaterial="currentMaterial"
                :learningObjective="learningObjectiveStore.learningObjective"
                :isAdaptativeLearning="true"
                @onChooseMaterial="(e) => materialStore.onChooseMaterial(e)"
                @onCloseStudentMap="materialStore.setShowMap"
              />

              <div class="flex items-center gap-2">
                <Button
                  class="btn-primary p-button-sm"
                  :disabled="isDisabledBackButton"
                  @click.prevent="onGoBack()"
                  icon="pi pi-chevron-left"
                  title="`Voltar objeto de aprendizagem`"
                />

                <Button
                  class="btn-primary p-button-sm"
                  @click.prevent="onGoNext()"
                  icon="pi pi-chevron-right"
                  title="`Próximo objeto de aprendizagem`"
                  :disabled="isDisableNextButton"
                />
              </div>
            </div>
          </div>

          <div
            v-if="materialStore?.isVideo"
            :class="`${flex} mt-4 flex-col z-10`"
          >
            <VideoComponent
              :data="currentMaterial?.file"
              :idVideo="currentMaterial?.file.id"
              :startTime="time"
              :isAdaptativeLearning="true"
              ref="videoComponent"
              :key="currentMaterial?.file?.id"
            />
            <Transcripts
              :material="currentMaterial"
              @onNeedsToPause="needsToPause"
              @onClickDuration="onSelectTranscriptionTime"
            />
          </div>
          <div v-if="materialStore?.isImage" :class="`${flex} mt-4`">
            <Image
              :src="currentMaterial?.file.url"
              alt="material-image"
              imageClass="w-full h-[100%] sm:h-[600px] lg:h-[600px] object-cover"
              preview
              :key="currentMaterial?.file?.id"
            />
          </div>
          <div v-if="materialStore?.isAudio" :class="`${flex} mt-4`">
            <audio
              id="material-audio"
              :src="currentMaterial.file.url"
              class="w-full h-[100%] sm:h-[600px] lg:h-[600px]"
              :key="currentMaterial?.file?.id"
            ></audio>
          </div>
          <div v-if="materialStore?.isPdf" :class="`${flex} mt-4`">
            <PDFComponent
              :url="currentMaterial?.file.url"
              :key="currentMaterial?.file?.id"
            />
          </div>
        </div>
      </section>
    </div>
    <div id="empty" v-else class="h-[80vh]">
      <EmptyData
        :data="!currentMaterial"
        :title="`${$t('studentCourse.empty.materialBeingWatch.title')}`"
        :label="`${$t('studentCourse.empty.materialBeingWatch.description')}`"
        :image="'empty-materials-watch.svg'"
        imgSize="h-40"
      />
    </div>
  </main>
</template>
<script lang="ts">
import EmptyData from "@/components/EmptyData/empty-data.vue";
import { MotionEnter, MotionInitial } from "@/models/motion.model";
import { useAdaptLoaderStore } from "@/store/adaptative/adapt-loader";
import { useAdaptMaterialStore } from "@/store/adaptative/adapt-material";
import { useLearningObjectiveStore } from "@/store/adaptative/learning-objective";
import { computed, defineAsyncComponent, defineComponent, ref } from "vue";
import { needsToPause } from "../../course-student.service";
const HistoryMaterials = defineAsyncComponent(
  () => import("@/components/Material/HistoryMaterials/history-materials.vue")
);
const SkipVideo = defineAsyncComponent(
  () => import("./../SkipVideo/skip-video.vue")
);
const Transcripts = defineAsyncComponent(
  () => import("@/components/Material/Transcripts/transcripts.vue")
);
export default defineComponent({
  name: "material",
  components: {
    HistoryMaterials,
    SkipVideo,
    Transcripts,
  },
  data() {
    return {
      flex: "flex justify-center w-full",
      time: 0,
      initialMotion: new MotionInitial(0, 0, 0),
      enterMotion: new MotionEnter(),
      typeModalHeader: "STUDENT",
      showAlert: true,
    };
  },

  setup() {
    const materialStore = useAdaptMaterialStore;
    const loaderStore = useAdaptLoaderStore;
    const learningObjectiveStore = useLearningObjectiveStore;

    function onVerifyMaterials() {
      materialStore?.goBack();
    }

    async function onGoNext() {
      await materialStore?.goNext();
    }

    function onGoBack() {
      materialStore?.goBack();
    }
    const isDisabledBackButton = computed(() => {
      return materialStore?.indexMaterial == 0;
    });
    const isDisableNextButton = computed(() => {
      return !materialStore?.canGoToQuiz && materialStore?.isLastMaterial;
    });
    const currentMaterial = computed(() => {
      return materialStore?.getCurrentMaterial;
    });
    return {
      materialStore,
      loaderStore,
      onVerifyMaterials,
      onGoNext,
      onGoBack,
      isDisabledBackButton,
      isDisableNextButton,
      currentMaterial,
      learningObjectiveStore,
    };
  },
  methods: {
    goToScreenInit() {
      (this.$refs.material as any)?.scrollTo(0, 0);
    },
    needsToPause(value: boolean): void {
      (this.$refs.videoComponent as any).needsToPause(value);
    },
    onSelectTranscriptionTime(event: any) {
      this.goToScreenInit();
      this.time = event;
    },
  },
});
</script>
